/**
 * Komponent umożliwiający odtwarzanie dźwięku po dobrej i złej odpowiedzi
 */
import Sounds from '../constans/sounds';
/**
 * Ustawienie dźwięków uywanych w aplikacji
 */
const good = new Audio(Sounds.goodAnswer);
const bad = new Audio(Sounds.badAnswer);
const gotoPark = new Audio(Sounds.gotoPark);
const gotoLocation = new Audio(Sounds.gotoLocation);
const menuButton = new Audio(Sounds.menuButton);
const challengeButton = new Audio(Sounds.challengeButton);
const nextQuestion = new Audio(Sounds.nextQuestion);
const takePhoto = new Audio(Sounds.takePhoto);
const recordSound = new Audio(Sounds.recordSound);
/**
 * Funkcja zatrzymująca odtwrzanie dźwięków
 */
 export const pause = () => {
     if(good){
         good.pause();
         good.currentTime = 0;
    }
    if(bad){
         bad.pause();
         bad.currentTime = 0;
    }
    if(gotoPark){
        gotoPark.pause();
        gotoPark.currentTime = 0;
    }
    if(gotoLocation){
        gotoLocation.pause();
        gotoLocation.currentTime = 0;
    }
    if(menuButton){
        menuButton.pause();
        menuButton.currentTime = 0;
    }
    if(challengeButton){
        challengeButton.pause();
        challengeButton.currentTime = 0;
    }
    if(nextQuestion){
        nextQuestion.pause();
        nextQuestion.currentTime = 0;
    }
    if(takePhoto){
        takePhoto.pause();
        takePhoto.currentTime = 0;
    }
    if(recordSound){
        recordSound.pause();
        recordSound.currentTime = 0;
    }
 }

const SoundEffect = (sound:string) => {
    pause();
    switch (sound) {
        case 'good':
            if(good) good.play();
            break;
        case 'bad':
            if(bad) bad.play();
            break;
        case 'gotoPark':
            if(gotoPark) gotoPark.play();
            break;
        case 'gotoLocation':
            if(gotoLocation) gotoLocation.play();
            break;
        case 'menuButton':
            if(menuButton) menuButton.play();
            break;
        case 'challengeButton':
            if(challengeButton) challengeButton.play();
            break;
        case 'nextQuestion':
            if(nextQuestion) nextQuestion.play();
            break;
        case 'takePhoto':
            if(takePhoto) takePhoto.play();
            break;
        case 'recordSound':
            if(recordSound) recordSound.play();
            break;
    }
}
 
 export default SoundEffect;